<div class="sidebar" [ngClass]="{ 'collapsed': isCollapsed && !isMobile}">
  <div class="sidebar-header">
    <div class="cursor-pointer logo" routerLink="admin/">
      <div class="header-content" *ngIf="!isCollapsed">
        <img src="/images/sidebar/logo.svg" alt="Cladded Glass Logo" />
        <p-button icon="pi pi-angle-double-left" class="toggle-btn" (click)="toggleSidebar()">
        </p-button>
      </div>
      <div *ngIf="isCollapsed">
        <p-button *ngIf="!isMobile" icon="pi pi-angle-double-right" class="toggle-btn" (click)="toggleSidebar()">
        </p-button>
      </div>
    </div>
  </div>

  <div *ngIf="isLoggedIn">
    <div class="flex items-center space-x-2 account-status" *ngIf="!isCollapsed">
      <p>Account Status:</p>
      <span class="status active">Active</span>
    </div>

    <!-- Full menu when expanded -->
    <p-panelMenu *ngIf="!isCollapsed" [model]="menuItems"></p-panelMenu>

    <!-- Icons-only menu when collapsed -->
    <p-panelMenu *ngIf="isCollapsed" [model]="collapsedMenuItems" class="collapsed-menu">
    </p-panelMenu>

    <div class="sidebar-footer logout">
      <p-button label="Logout" icon="pi pi-sign-out" class="logout-button" (click)="logout()"
        *ngIf="!isCollapsed"></p-button>
      <p-button icon="pi pi-sign-out" class="logout-icon-button" (click)="logout()" *ngIf="isCollapsed">
      </p-button>
    </div>
  </div>
</div>